import { getAdminMemberBaseUrl } from '../BaseUrl';

export interface NoticeEndpointsProps {
  get_notices_list: (page: number, size: number, keyword?: string) => string; // 공지사항 목록 조회
  get_notice_detail: (noticeId: string) => string; // 공지사항 상세 조회
}

export const NoticeEndpoints: NoticeEndpointsProps = {
  get_notices_list: (page, size, keyword) => {
    let url = `${getAdminMemberBaseUrl()}/notices?page=${page}&size=${size}`;
    if (keyword) {
      url += `&keyword=${encodeURIComponent(keyword)}`;
    }
    return url;
  },
  get_notice_detail: (noticeId: string) =>
    `${getAdminMemberBaseUrl()}/notices/${noticeId}`, // 공지사항 상세 조회
};

export default NoticeEndpoints;
